<template>
  <v-container v-if="!review">
    <div class="text-h4">Let us know your VLAN preference for this circuit.</div>
    <p>
      If you have a preference for what number we assign to this circuit's VLAN, type it below.
    </p>

    <h3 v-if="getProductInfo().vlan_preference === 'assign'">Will use Next Available</h3>
    <h3 v-if="getProductInfo().vlan_preference !== 'assign'">Will use custom VLAN {{ getProductInfo().vlan_preference }}
    </h3>

    <v-btn v-if="getProductInfo().vlan_preference === 'assign'" @click="setVLANPreference(1)">Enter Custom
      VLAN Preference</v-btn>

    <v-text-field v-if="getProductInfo().vlan_preference !== 'assign'" label="VLAN Preference" :value="getProductInfo().vlan_preference" type="number" min="1" max="4096"
      persistent-hint hint="Enter a number between 1 and 4096, or leave blank for assign" clearable
      @input="setVLANPreference"></v-text-field>

    <v-btn v-if="getProductInfo().vlan_preference !== 'assign'" @click="setVLANPreference('assign')">Use Next
      Available</v-btn>

  </v-container>
  <div v-else>
    <ReviewItem label="What is your VLAN Preference?" :value="getProductInfo().vlan_preference" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ReviewItem from '@/components/ReviewItem.vue';

export default {
  name: 'VLAN',
  props: {
    review: {
      required: false,
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  mounted() {
    if (!this.getProductInfo().vlan_preference) {
      this.setVLANPreference('assign');
    }
  },
  methods: {
    ...mapActions(['updateStoreFormData']),
    setVLANPreference(newVal) {
      this.updateStoreFormData({
        data: newVal,
        main: this.getProductIdSelected,
        sub: 'vlan_preference',
      });
    },
    isValidNumber(value) {
      if (typeof value === 'number') {
        return Number.isFinite(value);
      }

      if (typeof value === 'string') {
        const trimmed = value.trim();
        return trimmed !== '' && Number.isFinite(Number(trimmed));
      }

      return false;
    },
  },
  computed: {
    ...mapGetters(['getProductIdSelected', 'getProductInfo']),
    VLANs() { // Returns a list of strings from 0000 to 4096
      const items = ['assign'];
      return items.concat(Array.from({ length: 4096 + 1 }, (v, i) => i.toString().padStart(4, '0')));
    },
  },
  components: {
    ReviewItem,
  },
};
</script>
